module.exports = __webpack_public_path__ + "static/media/Portuguese_Brazilian_Marcela BG-52.98bc8f5b.png";